import { Modal, Form, Input, Cascader, Button } from "antd";
import { allRoles, rolePrettyNames } from "../constants/roles";

const roleOptions = allRoles.map((role) => ({
  value: role,
  label: rolePrettyNames[role] ?? role,
  disabled: role === "DASHBOARD_USER",
}));

const EditUserModal = ({
  user,
  isLoading,
  isOpen,
  onClose,
  onFinish,
}) => {
  const [form] = Form.useForm();

  if (!user) return null;

  const defaultRoles = user.roles.map((r) => [r]);

  const handleOk = () => form.submit();

  const handleFinish = (values) => {
    const payload = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v !== null && v !== undefined && v !== "")
    );
    if (payload.roles) {
      payload.roles = payload.roles.flat(Infinity);
    }
    onFinish(payload, user.user_id);
  };

  return (
    <Modal
      title={`Edit - ${user.first_name} ${user.last_name}`}
      open={isOpen}
      onOk={handleOk}
      onCancel={onClose}
      okText="Save Changes"
      confirmLoading={isLoading}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          telephone_number: user.telephone_number,
          county: user.county,
          authority: user.authority,
          roles: defaultRoles,
        }}
        onFinish={handleFinish}
        preserve={false}
      >
        <Form.Item label="First Name" name="first_name">
          <Input />
        </Form.Item>
        <Form.Item label="Last Name" name="last_name">
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ type: "email", message: "Enter a valid email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Phone" name="telephone_number">
          <Input />
        </Form.Item>
        <Form.Item label="County" name="county">
          <Input />
        </Form.Item>
        <Form.Item label="Authority" name="authority">
          <Input />
        </Form.Item>
        <Form.Item label="Roles" name="roles">
          <Cascader
            options={roleOptions}
            multiple
            maxTagCount="responsive"
            showSearch={{
              filter: (input, path) =>
                path.some((o) => o.label.toLowerCase().includes(input.toLowerCase())),
            }}
            placeholder="Select roles"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUserModal;